<template>
    <span @click="loadInvoice" class="view-invoice">{{ loadingInvoice ? 'Loading...' : 'View Invoice'}}</span>
    <div v-if="isActive" class="c-invoice-modal">
        <div class="c-invoice-modal__inner">
            <div class="c-invoice-modal__content">
                <div @click="closeModal" class="c-invoice-modal__close"></div>
                <h2>Invoice {{ invoiceData.id }}</h2>
                <div class="c-invoice-modal__section dates">
                    <p><b>Invoice Date:</b> {{ formatDate(invoiceData.attributes.invoiceDate) }}</p>
                    <p><b>Due Date:</b> {{ formatDate(invoiceData.attributes.dueDate) }}</p>
                </div>
                <div class="c-invoice-modal__section items">
                    <p><b>On Hold? :</b> {{ invoiceData.attributes.isOnHold ? 'Yes' : 'No' }}</p>
                    <p><b>Paid? :</b> {{ invoiceData.attributes.isPaid ? 'Yes' : 'No' }}</p>
                    <p><b>Posted? :</b> {{ invoiceData.attributes.isPosted ? 'Yes' : 'No' }}</p>
                    <p><b>Printed? :</b> {{ invoiceData.attributes.isPrinted ? 'Yes' : 'No' }}</p>
                    <p><b>Voided? :</b> {{ invoiceData.attributes.isVoided ? 'Yes' : 'No' }}</p>
                    <p><b>Order Status:</b> {{ invoiceData.attributes.orderStatus }}</p>
                </div>
                <div class="c-invoice-modal__section addresses">
                    <p><b>Bill To Address:</b><br/> {{ invoiceData.attributes.billToAddress }}, {{ invoiceData.attributes.billToCity }}, {{ invoiceData.attributes.billToPostalCode }}</p>
                    <p><b>Shipping Address:</b><br/> {{ invoiceData.attributes.shipToAddress }}, {{ invoiceData.attributes.shipToCity }}, {{ invoiceData.attributes.shipToPostalCode }}</p>
                </div>
                <div class="c-invoice-modal__section totals">
                    <p><b>Subtotal:</b> £{{ invoiceData.attributes.subTotal }}</p>
                    <p><b>Tax:</b> £{{ invoiceData.attributes.tax }}</p>
                    <p><b>Shipping:</b> £{{ invoiceData.attributes.freight }}</p>
                    <p><b>Amount Due:</b> £{{ invoiceData.attributes.total }}</p>
                    <p><b>Amount Paid:</b> £{{ invoiceData.attributes.amountPaid }}</p>
                    <p><b>Outstanding Balance:</b> £{{ parseFloat(invoiceData.attributes.balance).toFixed(2) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InvoiceModal',
        props: {
            poCode: {
                type: String,
                required: true
            },
            accountNumber: {
                type: String,
                required: true
            }
        },
        methods: {
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${day}/${month}/${year}`;
            },
            async loadInvoice() {
                this.loadingInvoice = true;

                try {
                    const response = await fetch(
                        `/rest/V1/swallowdental/invoice?type=PO&search=${this.poCode}`,
                    );

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    const invoice = data[0][0];
                    this.isActive = true;
                    this.invoiceData = invoice;
                    this.loadingInvoice = false;

                } catch (error) {
                    this.loadingInvoice = false;
                    alert('Invoice not found');
                    console.error("Error fetching transactions:", error);
                }
            },
            closeModal() {
                this.isActive = false;
                this.invoiceData = null;
            }
        },
        data() {
            return {
                isActive: false,
                loadingInvoice: false,
                invoiceData: null
            };
        }
    }
</script>